export const gateway_web = 'gateway_web';